module.exports = __webpack_public_path__ + "static/img/MTZN52G4OMs.e19f951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/MTZN52G4OMs.png
// module id = 3y9p
// module chunks = 1